/* HANSE Zauntechnik – Zaunkonfigurator: Sichtschutz-Zweig (GroJa)
   Ergänzt den bestehenden Doppelstab-Konfigurator um:
   - Startfrage Doppelstab / Sichtschutz  (window.kChooseCat)
   - Kompletten Sichtschutz-Flow: Zauntyp > Modell > Oberfläche > Länge > Tor > Boden > Extras > Übersicht
   Stand: 2026-07-19 – Varianten-IDs aus Shopify
*/
(function () {
  'use strict';

  var CDN = 'https://cdn.shopify.com/s/files/1/0801/5442/7727/files/';

  /* Pfosten: e = Einbetonieren (240 cm), a = Aufdübeln (190 cm, für Fußplatte) */
  var POST = {
    lumino:   { e:{anthrazit:{id:57712295870799,price:147.48}, silber:{id:57712295903567,price:147.48}},
                a:{anthrazit:{id:57712295739727,price:136.02}, silber:{id:57712295772495,price:136.02}} },
    solid:    { e:{anthrazit:{id:57712695411023,price:105.71}, silber:{id:57712695411023,price:105.71}},
                a:{anthrazit:{id:57712695378255,price:88.49},  silber:{id:57712695378255,price:88.49}} },
    alu7:     { e:{anthrazit:{id:57733152538959,price:103.17}, silber:{id:57733152571727,price:103.17}},
                a:{anthrazit:{id:57733152473423,price:92.05},  silber:{id:57733152506191,price:92.05}} },
    viento:   { e:{anthrazit:{id:57726023991631,price:99.04},  silber:{id:57726024024399,price:99.04}},
                a:{anthrazit:{id:57726023926095,price:90.79},  silber:{id:57726023958863,price:90.79}} },
    ambiente: { e:{anthrazit:{id:57712698655055,price:99.04},  silber:{id:57712698655055,price:99.04}},
                a:{anthrazit:{id:57712698523983,price:90.79},  silber:{id:57712698523983,price:90.79}} }
  };
  /* Fußplatte: immer der Montageadapter, 1x je Pfosten (ersetzt die Konsolen GJ 48/GJ 43) */
  var ADAPTER = { id:57733157912911, price:37.85, label:'Montageadapter (für alle Konsolen)' };

  /* LED: 1 Leiste je Pfosten */
  var LED = { id:57732885152079, price:78.45 };

  /* Torpfosten: 2 Stück je Tor, immer 240 cm zum Einbetonieren (tragen die Torlast) */
  var TORPFOSTEN = {
    solid:    { label:'GroJa Solid Torpfosten 10×10 cm, 240 cm',
                terra:{id:57712691380559,price:146.67}, anthrazit:{id:57712691347791,price:146.67}, silber:{id:57712691347791,price:146.67} },
    ambiente: { label:'GroJa Ambiente Alu-Torpfosten 240 cm',
                anthrazit:{id:57712699048271,price:163.86}, silber:{id:57712699048271,price:163.86} },
    alu99:    { label:'GroJa Alu-Torpfosten 9×9 cm, 240 cm (stahlverstärkt)',
                anthrazit:{id:57733155029327,price:278.57}, silber:{id:57733155062095,price:278.57} }
  };

  /* Verbindungswinkel: 1 Set je Fertigzaun-Feld */
  var WINKEL = {
    winkelset:  { id:57229355942223, price:26.35, label:'Winkelset für WPC Fertigzaun-Systeme (6er Set)' },
    vientowink: { id:57712406167887, price:24.85, label:'GroJa Viento Befestigungswinkel (8er Set)' }
  };

  var MODELS = {
    lumino: {
      typ:'steckzaun', name:'GroJa Lumino Aluminium', ew:1.80, img:CDN+'IMG-0705.webp',
      sub:'Moderner Aluminium-Steckzaun, wartungsfrei', post:'lumino', torp:'alu99', led:true, schraeg:null,
      colors:[
        {k:'anthrazit',l:'Anthrazit DB 703',img:CDN+'IMG-0705.webp',vid:57711771812175,p:608.72,pc:'anthrazit'},
        {k:'silber',l:'Silbergrau',img:CDN+'IMG-0706.webp',vid:57711771844943,p:608.72,pc:'silber'}
      ],
      tor:[{k:'anthrazit',l:'Anthrazit DB 703',vid:57712233480527,p:1451.85},{k:'silber',l:'Silbergrau',vid:57712233513295,p:1176.78}]
    },
    basicline: {
      typ:'steckzaun', name:'GroJa BasicLine', ew:1.80, img:CDN+'1700_270bd834-2983-4b8e-a426-cc4330ae7e9f.jpg',
      sub:'Preiswerter WPC-Steckzaun in vielen Dekoren', post:'alu7', torp:'alu99', led:true, schraeg:null,
      colors:[
        {k:'weiss',l:'Weiß',img:CDN+'1700.jpg',vid:57743866069327,p:218.48,pc:'anthrazit'},
        {k:'anthrazit',l:'Anthrazit DB 703',img:CDN+'1700_270bd834-2983-4b8e-a426-cc4330ae7e9f.jpg',vid:57743866102095,p:347.96,pc:'anthrazit'},
        {k:'silber',l:'Silbergrau EV1',img:CDN+'1700_a70399a4-421d-41c3-b8a5-c767e983eb2c.jpg',vid:57743866134863,p:347.96,pc:'silber'},
        {k:'sheffield',l:'Sheffield Oak',img:CDN+'1700_7cad6e7e-a552-474e-9f7d-56492e078b50.jpg',vid:57743866167631,p:347.96,pc:'anthrazit'},
        {k:'asteiche',l:'Asteiche Natur',img:CDN+'1700_b0205bcf-f30f-4afd-94c7-456d7a70ae64.jpg',vid:57743866200399,p:347.96,pc:'anthrazit'},
        {k:'golden',l:'Golden Oak',img:CDN+'1700_49b5b82f-c212-4d1d-be16-bb93e46f300f.jpg',vid:57743866233167,p:347.96,pc:'anthrazit'},
        {k:'monument',l:'Monument Oak',img:CDN+'1700_ddbdb735-92d8-4e45-99a0-6a0910b6e60f.jpg',vid:57743866265935,p:347.96,pc:'anthrazit'},
        {k:'greyash',l:'Grey Ash Cut',img:CDN+'1700_530277f0-e836-4b66-8bbc-08a622f946d5.jpg',vid:57743866298703,p:347.96,pc:'anthrazit'}
      ],
      tor:[{k:'weiss',l:'Weiß',vid:57743881306447,p:1077.67},{k:'anthrazit',l:'Anthrazit DB 703',vid:57743881339215,p:1077.67},{k:'silber',l:'Silbergrau EV1',vid:57743881371983,p:1077.67},{k:'sheffield',l:'Sheffield Oak',vid:57743881404751,p:1077.67},{k:'golden',l:'Golden Oak',vid:57743881437519,p:1077.67},{k:'monument',l:'Monument Oak',vid:57743881470287,p:1077.67},{k:'greyash',l:'Grey Ash Cut',vid:57743881503055,p:1077.67}]
    },
    solid: {
      typ:'steckzaun', name:'GroJa Solid', ew:1.80, img:CDN+'210717153600010_GroJaSolid_Steckzaun_Anthrazitgrau.png',
      sub:'WPC-Steckzaun in warmer Holzoptik', post:'solid', torp:'solid', led:true, schraeg:null,
      colors:[
        {k:'anthrazitgrau',l:'Anthrazitgrau',img:CDN+'210717153600010_GroJaSolid_Steckzaun_Anthrazitgrau.png',vid:57743880880463,p:267.04,pc:'anthrazit'},
        {k:'terra',l:'Terra',img:CDN+'210717111910010_GroJaSolid_Steckzaun_Terra_d22457d0-0979-4de9-a7cf-9987e0ac47c4.png',vid:57743880913231,p:267.04,pc:'anthrazit'},
        {k:'bicolorsand',l:'Bi-Color Sand',img:CDN+'210717141100010_GroJaSolid_Steckzaun_Bi-Color-Sand.png',vid:57743880945999,p:267.04,pc:'anthrazit'},
        {k:'grau',l:'Grau',img:CDN+'210717157600010_GroJaSolid_Steckzaun_Grau.png',vid:57743880978767,p:267.04,pc:'silber'},
        {k:'walnuss',l:'Walnuss co-ex.',img:CDN+'210717151600010_GroJaSolid_Steckzaun_Walnuss-co-ex.png',vid:57743881011535,p:301.43,pc:'anthrazit'},
        {k:'steingrau',l:'Steingrau co-ex.',img:CDN+'210717152600010_GroJaSolid_Steckzaun_Steingrau-co-ex.png',vid:57743881044303,p:301.43,pc:'anthrazit'},
        {k:'bicolorcoex',l:'Bi-Color co-ex.',img:CDN+'210717155600010_GroJaSolid_Steckzaun_Bi-Color-co-ex.png',vid:57743881077071,p:301.43,pc:'anthrazit'},
        {k:'schwarz',l:'Schwarz co-ex.',img:CDN+'210717156600010_GroJaSolid_Steckzaun_Schwarz-co-ex.png',vid:57743881109839,p:232.65,pc:'anthrazit'}
      ],
      tor:[{k:'terra',l:'Terra',vid:57726100111695,p:846.02},{k:'anthrazitgrau',l:'Anthrazitgrau',vid:57726100144463,p:846.02},{k:'bicolorsand',l:'Bi-Color Sand',vid:58229584068943,p:846.02},{k:'steingrau',l:'Steingrau co-ex.',vid:58229584101711,p:846.02},{k:'walnuss',l:'Walnuss co-ex.',vid:58229584134479,p:846.02},{k:'schwarz',l:'Schwarz co-ex.',vid:58229584167247,p:846.02},{k:'bicolorcoex',l:'Bi-Color co-ex.',vid:58229584200015,p:846.02},{k:'grau',l:'Grau',vid:58229584232783,p:846.02}]
    },
    fertigquad: {
      typ:'fertigzaun', name:'GroJa Fertigzaun Quadratisch', ew:1.80, img:CDN+'1700_0573125a-5b8a-4b1e-b248-aa09d95da6f8.jpg',
      sub:'Vorgefertigtes 180×180-Element, schnell montiert', post:'alu7', torp:'alu99', winkel:'winkelset', led:false, torSelect:true,
      colors:[
        {k:'anthrazit-ev1',l:'Anthrazit, Querriegel EV1',img:CDN+'1700_0573125a-5b8a-4b1e-b248-aa09d95da6f8.jpg',vid:57743882223951,p:192.19,pc:'silber'},
        {k:'hellgrau-ev1',l:'Hellgrau, Querriegel EV1',img:CDN+'1700_9496445c-707a-4d02-add9-61285f3bf58f.jpg',vid:57743882256719,p:192.19,pc:'silber'},
        {k:'bicolor-ev1',l:'Bi-Color Sand, Querriegel EV1',img:CDN+'1700_29bd41ef-ccae-4004-ae2f-63bbf54c8438.jpg',vid:57743882289487,p:212.42,pc:'silber'},
        {k:'steingrau-ev1',l:'Steingrau co-ex, Querriegel EV1',img:CDN+'1700_c70f3fab-bf76-4cd7-805a-c71bfa52fc33.jpg',vid:57743882322255,p:242.76,pc:'silber'},
        {k:'anthrazit-db703',l:'Anthrazit, Querriegel DB 703',img:CDN+'1700_21805379-a7c2-4fe7-9679-8acecc99944f.jpg',vid:57743882355023,p:192.19,pc:'anthrazit'}
      ],
      schraeg:{'anthrazit-ev1':{id:57743882781007,p:145.66},'hellgrau-ev1':{id:57743882813775,p:145.66},'bicolor-ev1':{id:57743882846543,p:151.73},'steingrau-ev1':{id:57743882879311,p:182.07},'anthrazit-db703':{id:57743882912079,p:145.66}},
      tor:[{k:'x',l:'Anthrazit · DIN links · Rahmen EV1',vid:57743883010383,p:708.70},{k:'x',l:'Anthrazit · DIN rechts · Rahmen EV1',vid:57743883043151,p:708.70},{k:'x',l:'Hellgrau · DIN links · Rahmen EV1',vid:57743883075919,p:708.70},{k:'x',l:'Hellgrau · DIN rechts · Rahmen EV1',vid:57743883108687,p:708.70},{k:'x',l:'Bi-Color Sand · DIN links · Rahmen EV1',vid:57743883141455,p:708.70},{k:'x',l:'Bi-Color Sand · DIN rechts · Rahmen EV1',vid:57743883174223,p:708.70},{k:'x',l:'Anthrazit · DIN links · Rahmen DB 703',vid:57743883206991,p:708.70},{k:'x',l:'Anthrazit · DIN rechts · Rahmen DB 703',vid:57743883239759,p:708.70}]
    },
    viento: {
      typ:'fertigzaun', name:'GroJa Viento Zaunelement', ew:1.80, img:CDN+'210717241100300_GroJaViento_Anthrazitgrau_DB703.png',
      sub:'Design-Element mit Alu-Rahmen, hochwertig', post:'viento', torp:'alu99', winkel:'vientowink', led:false,
      colors:[
        {k:'anthr-db703',l:'Anthrazitgrau, Rahmen DB 703',img:CDN+'210717241100300_GroJaViento_Anthrazitgrau_DB703.png',vid:57726008721743,p:303.45,pc:'anthrazit'},
        {k:'anthr-ev1',l:'Anthrazitgrau, Rahmen EV1',img:CDN+'210717241100300_GroJaViento_Anthrazitgrau_DB703.png',vid:57726008754511,p:303.45,pc:'silber'},
        {k:'bicolor-db703',l:'Bi-Color Sand, Rahmen DB 703',img:CDN+'210717241100300_GroJaViento_Anthrazitgrau_DB703.png',vid:57726008787279,p:323.68,pc:'anthrazit'},
        {k:'bicolor-ev1',l:'Bi-Color Sand, Rahmen EV1',img:CDN+'210717241100300_GroJaViento_Anthrazitgrau_DB703.png',vid:57726008820047,p:323.68,pc:'silber'},
        {k:'steingrau-db703',l:'Steingrau co-ex., Rahmen DB 703',img:CDN+'210717241100300_GroJaViento_Anthrazitgrau_DB703.png',vid:57726008852815,p:394.49,pc:'anthrazit'},
        {k:'walnuss-db703',l:'Walnuss co-ex., Rahmen DB 703',img:CDN+'210717241100300_GroJaViento_Anthrazitgrau_DB703.png',vid:57726008885583,p:394.49,pc:'anthrazit'}
      ],
      schraeg:{'anthr-db703':{id:57726015963471,p:202.30},'anthr-ev1':{id:57726015996239,p:202.30},'bicolor-db703':{id:57726016029007,p:222.53},'bicolor-ev1':{id:57726016061775,p:222.53},'steingrau-db703':{id:57726016094543,p:303.45},'walnuss-db703':{id:57726016127311,p:303.45}},
      tor:[{k:'anthr-db703',l:'Anthrazitgrau, Rahmen DB 703',vid:57726017700175,p:1042.47},{k:'anthr-ev1',l:'Anthrazitgrau, Rahmen EV1',vid:57726017732943,p:844.28},{k:'bicolor-db703',l:'Bi-Color Sand, Rahmen DB 703',vid:57726017765711,p:1042.47},{k:'bicolor-ev1',l:'Bi-Color Sand, Rahmen EV1',vid:57726017798479,p:844.28},{k:'steingrau-db703',l:'Steingrau, Rahmen DB 703',vid:57726017831247,p:1042.47},{k:'walnuss-db703',l:'Walnuss, Rahmen DB 703',vid:57726017864015,p:1042.47}]
    },
    ambiente: {
      typ:'glaszaun', name:'GroJa Ambiente Glaszaun', ew:0.90, img:CDN+'1700_1cac5e89-3db7-4b45-8602-60cd93d942b1.jpg',
      sub:'Senkrecht 90 (90 cm breit) · Glaselement mit Alu-Pfosten', post:'ambiente', torp:'ambiente', led:false, forcePc:'anthrazit', torSelect:true,
      colors:[
        {k:'klarglas',l:'Klarglas',img:CDN+'1700_1cac5e89-3db7-4b45-8602-60cd93d942b1.jpg',vid:57712696164687,p:158.02,pc:'anthrazit'},
        {k:'satiniert',l:'Komplett Satiniert',img:CDN+'1700_edb0a892-81cc-4feb-a8a5-bb537978daed.jpg',vid:57712696197455,p:246.81,pc:'anthrazit'},
        {k:'streifen',l:'Streifen',img:CDN+'1700_5d541a90-d18d-4c60-bd9c-956c469f8675.jpg',vid:57712696230223,p:246.81,pc:'anthrazit'},
        {k:'blockstreifen',l:'Blockstreifen',img:CDN+'1700_10fc0317-b390-40b5-ae85-daafddd87b6c.jpg',vid:57712696262991,p:246.81,pc:'anthrazit'}
      ],
      schraeg:{'klarglas':{id:57712696426831,p:226.36},'satiniert':{id:57712696459599,p:313.57},'streifen':{id:57712696492367,p:313.57},'blockstreifen':{id:57712696525135,p:313.57}},
      tor:[{k:'x',l:'EV1 Silber · Universal · Klarglas',vid:57712697246031,p:1176.17},{k:'x',l:'Anthrazit DB 703 · Universal · Klarglas',vid:57712697475407,p:1291.51}]
    }
  };

  var TYPEN = {
    steckzaun:  {l:'Steckzaun',  sub:'Flexible Breiten &amp; Höhen',        icon:'🧩', models:['lumino','basicline','solid']},
    fertigzaun: {l:'Fertigzaun', sub:'Fertige 180×180-Elemente',            icon:'🏗️', models:['fertigquad','viento']},
    glaszaun:   {l:'Glaszaun',   sub:'Elegante Glas-Sichtschutzelemente',   icon:'🪟', models:['ambiente']}
  };

  var S = { typ:null, model:null, color:null, laenge:'', tor:false, torIdx:null, mount:null, schraeg:false, led:false };

  function fmt(n){ return n.toFixed(2).replace('.',',')+' €'; }
  function M(){ return S.model ? MODELS[S.model] : null; }
  function esc(s){ return String(s).replace(/"/g,'&quot;'); }
  function pcolOf(){
    var m=M(); if(!m) return 'anthrazit';
    if(m.forcePc) return m.forcePc;
    for(var i=0;i<m.colors.length;i++){ if(m.colors[i].k===S.color) return m.colors[i].pc; }
    return 'anthrazit';
  }
  function colorObj(){ var m=M(); if(!m) return null; for(var i=0;i<m.colors.length;i++){ if(m.colors[i].k===S.color) return m.colors[i]; } return null; }

  function screens(){
    var m=M(); var a=['typ','modell','farbe','laenge'];
    if(m && m.tor && m.tor.length) a.push('tor');
    a.push('montage');
    if(m && (m.schraeg || m.led)) a.push('extras');
    a.push('summary');
    return a;
  }
  var LABELS={typ:'Zauntyp',modell:'Modell',farbe:'Oberfläche',laenge:'Länge',tor:'Tor',montage:'Boden',extras:'Extras',summary:'Übersicht'};

  function calc(){
    var m=M(); var c=colorObj();
    var l=parseFloat(String(S.laenge).replace(',','.'))||0;
    if(!m||!c||l<=0) return null;
    var el=Math.ceil(l/m.ew), po=el+1;
    var pc=pcolOf();
    var pv=(S.mount==='fussplatte')?POST[m.post].a[pc]:POST[m.post].e[pc];
    var stdCount=(S.schraeg&&m.schraeg)?Math.max(0,el-1):el;
    var rows=[], items=[], total=0;

    if(stdCount>0){ var sub=c.p*stdCount; total+=sub; items.push({id:c.vid,quantity:stdCount});
      rows.push({name:m.name+' – '+c.l+' (180 cm hoch)',qty:stdCount,ep:c.p,sub:sub}); }

    if(S.schraeg&&m.schraeg&&m.schraeg[S.color]){ var sc=m.schraeg[S.color]; total+=sc.p; items.push({id:sc.id,quantity:1});
      rows.push({name:m.name+' – Schräg-Endelement',qty:1,ep:sc.p,sub:sc.p}); }

    if(pv&&po>0){ var psub=pv.price*po; total+=psub; items.push({id:pv.id,quantity:po});
      rows.push({name:'Pfosten '+(S.mount==='fussplatte'?'190 cm (zum Aufdübeln)':'240 cm (zum Einbetonieren)')+' – inkl. Eckpfosten',qty:po,ep:pv.price,sub:psub}); }

    /* Verbindungswinkel: 1 Set je Fertigzaun-Feld (Schräg-Element zählt mit) */
    if(m.winkel && WINKEL[m.winkel]){ var w=WINKEL[m.winkel]; var wsub=w.price*el; total+=wsub; items.push({id:w.id,quantity:el});
      rows.push({name:w.label,qty:el,ep:w.price,sub:wsub}); }

    /* Fußplatte: Montageadapter, 1x je Pfosten */
    if(S.mount==='fussplatte'){ var asub=ADAPTER.price*po; total+=asub; items.push({id:ADAPTER.id,quantity:po});
      rows.push({name:ADAPTER.label,qty:po,ep:ADAPTER.price,sub:asub}); }

    /* Tor inkl. 2 Torpfosten */
    if(S.tor&&S.torIdx!==null&&m.tor&&m.tor[S.torIdx]){
      var t=m.tor[S.torIdx]; total+=t.p; items.push({id:t.vid,quantity:1});
      rows.push({name:'Tor – '+t.l,qty:1,ep:t.p,sub:t.p});
      var tp=TORPFOSTEN[m.torp];
      if(tp){
        var tpv=(m.torp==='solid'&&S.color==='terra')?tp.terra:(tp[pc]||tp.anthrazit);
        if(tpv){ var tpsub=tpv.price*2; total+=tpsub; items.push({id:tpv.id,quantity:2});
          rows.push({name:tp.label,qty:2,ep:tpv.price,sub:tpsub}); }
      }
    }

    /* LED: 1 Lichtleiste je Pfosten */
    if(S.led&&m.led){ var lsub=LED.price*po; total+=lsub; items.push({id:LED.id,quantity:po});
      rows.push({name:'GroJaGlow LED-Lichtleiste 190 cm (Trafo separat)',qty:po,ep:LED.price,sub:lsub}); }

    return {el:el, po:po, total:total, items:items, rows:rows};
  }

  function progressHtml(cur){
    var scr=screens(), idx=scr.indexOf(cur), h='';
    for(var i=0;i<scr.length;i++){
      var cls='step-pill'+(i===idx?' active':(i<idx?' done':''));
      h+='<div class="'+cls+'"><span class="num">'+(i+1)+'</span><span class="lbl">'+LABELS[scr[i]]+'</span></div>';
      if(i<scr.length-1) h+='<div class="step-line'+(i<idx?' done':'')+'"></div>';
    }
    return h;
  }

  function render(screen){
    var wrap=document.getElementById('konfig-ssz'); if(!wrap) return;
    var m=M(), h='';

    h+='<div class="konfig-header"><h1>Sichtschutzzaun konfigurieren</h1>'
      +'<p>Blickdichte GroJa-Anlagen – mit sofortiger Stückliste und direktem Warenkorb.</p></div>';
    h+='<div class="konfig-progress">'+progressHtml(screen)+'</div>';
    /* Inline-display, damit goTo() der Doppelstab-JS dieses Panel nicht ausblenden kann */
    h+='<div class="konfig-panel active" style="display:block">';

    if(screen==='typ'){
      h+='<h2 class="konfig-step-title">Schritt 1: Zauntyp wählen</h2><p class="konfig-step-sub">Welche Bauart soll dein Sichtschutz haben?</p><div class="option-cards">';
      for(var k in TYPEN){ var t=TYPEN[k];
        h+='<div class="option-card'+(S.typ===k?' selected':'')+'" onclick="sszPick(\'typ\',\''+k+'\')"><h3>'+t.icon+' '+t.l+'</h3><p>'+t.sub+'</p></div>';
      }
      h+='</div>';
    }
    else if(screen==='modell'){
      var t2=TYPEN[S.typ];
      h+='<h2 class="konfig-step-title">Schritt 2: Modell wählen</h2><p class="konfig-step-sub">'+t2.l+' – alle Modelle 180 cm hoch, wartungsfrei und wetterfest.</p><div class="option-cards">';
      for(var i=0;i<t2.models.length;i++){ var mk=t2.models[i], mm=MODELS[mk];
        h+='<div class="option-card'+(S.model===mk?' selected':'')+'" onclick="sszPick(\'model\',\''+mk+'\')">'
          +'<img src="'+mm.img+'" alt="'+esc(mm.name)+'" style="width:100%;height:130px;object-fit:cover;border-radius:8px;margin-bottom:.7rem;background:#f2f2f2">'
          +'<h3>'+mm.name+'</h3><p>'+mm.sub+'<br><strong>ab '+fmt(mm.colors[0].p)+'/Element</strong></p></div>';
      }
      h+='</div>';
    }
    else if(screen==='farbe'){
      h+='<h2 class="konfig-step-title">Schritt 3: '+(m.typ==='glaszaun'?'Glas-Dekor':'Oberfläche')+' wählen</h2>'
        +'<p class="konfig-step-sub">'+(m.typ==='glaszaun'?'Standard-Element: Senkrecht 90 (90 cm breit).':'Elementbreite 180 cm, Höhe 180 cm.')+'</p>'
        +'<div class="option-cards" style="grid-template-columns:repeat(auto-fit,minmax(150px,1fr))">';
      for(var j=0;j<m.colors.length;j++){ var c=m.colors[j];
        h+='<div class="option-card'+(S.color===c.k?' selected':'')+'" onclick="sszPick(\'color\',\''+c.k+'\')" style="padding:1rem">'
          +'<img src="'+c.img+'" alt="'+esc(c.l)+'" style="width:100%;height:90px;object-fit:cover;border-radius:6px;margin-bottom:.5rem;background:#f2f2f2">'
          +'<h3 style="font-size:.92rem">'+c.l+'</h3><p><strong>'+fmt(c.p)+'</strong></p></div>';
      }
      h+='</div>';
    }
    else if(screen==='laenge'){
      h+='<h2 class="konfig-step-title">Schritt 4: Zaunlänge eingeben</h2>'
        +'<p class="konfig-step-sub">Gib die Gesamtlänge in Metern ein – Elemente und Pfosten werden automatisch berechnet.</p>'
        +'<div class="laenge-group"><label for="ssz-laenge">Länge:</label>'
        +'<input type="number" id="ssz-laenge" min="1" step="0.5" placeholder="z. B. 20" value="'+esc(S.laenge)+'" oninput="sszLen(this)"><span class="laenge-unit">Meter</span></div>'
        +'<div class="laenge-preview" id="ssz-preview"></div>'
        +'<p style="font-size:.8rem;color:var(--grey);margin:0">Berechnung: Elemente = ⌈Länge ÷ '+m.ew.toFixed(2).replace('.',',')+'⌉ &nbsp;|&nbsp; Pfosten = Elemente + 1 (Eckpfosten sind normale Pfosten und bereits enthalten)</p>';
    }
    else if(screen==='tor'){
      h+='<h2 class="konfig-step-title">Schritt 5: Tor hinzufügen?</h2><p class="konfig-step-sub">Passendes Tor aus derselben Serie.</p>';
      if(!m.tor||!m.tor.length){
        h+='<div class="konfig-alert visible" style="position:static">Für dieses Modell ist kein passendes Tor verfügbar.</div>';
      } else {
        h+='<div class="radio-group">'
          +'<button class="radio-btn'+(!S.tor?' selected':'')+'" onclick="sszTor(false)">Kein Tor</button>'
          +'<button class="radio-btn'+(S.tor?' selected':'')+'" onclick="sszTor(true)">Ja, Tor hinzufügen</button></div>';
        if(S.tor){
          h+='<label class="konfig-select-label" for="ssz-tor">Tor-Ausführung:</label><select class="konfig-select" id="ssz-tor" onchange="sszTorSel(this)">';
          for(var ti=0;ti<m.tor.length;ti++){
            h+='<option value="'+ti+'"'+(S.torIdx===ti?' selected':'')+'>'+m.tor[ti].l+' – '+fmt(m.tor[ti].p)+'</option>';
          }
          h+='</select>';
        }
      }
    }
    else if(screen==='montage'){
      h+='<h2 class="konfig-step-title">Schritt 6: Bodenbefestigung wählen</h2>'
        +'<p class="konfig-step-sub">Die Befestigung hängt von deiner Bodensituation ab.</p><div class="befestigung-cards">'
        +'<div class="befestigung-card'+(S.mount==='einbetonieren'?' selected':'')+'" onclick="sszPick(\'mount\',\'einbetonieren\')"><div class="icon">🏗️</div><h4>Einbetonieren</h4><p>Pfosten 240 cm – maximale Stabilität, im Erdreich einbetoniert.</p></div>'
        +'<div class="befestigung-card'+(S.mount==='fussplatte'?' selected':'')+'" onclick="sszPick(\'mount\',\'fussplatte\')"><div class="icon">🔩</div><h4>Fußplatte</h4><p>Pfosten 190 cm + Montagekonsolen – auf Beton oder Pflaster aufdübeln.</p></div>'
        +'</div>';
    }
    else if(screen==='extras'){
      h+='<h2 class="konfig-step-title">Schritt 7: Extras</h2><p class="konfig-step-sub">Optionale Ergänzungen – einfach weiterklicken, wenn du keine möchtest.</p><div class="extras-list">';
      if(m.schraeg){
        h+='<label class="extra-item'+(S.schraeg?' selected':'')+'" onclick="sszToggle(\'schraeg\')"><input type="checkbox"'+(S.schraeg?' checked':'')+' onclick="event.preventDefault()">'
          +'<div><h4>Letztes Element als Schräg-Element</h4><p>Ersetzt 1 Standard-Element durch ein Schräg-Element – ideal für Hanglage oder als sauberer Abschluss.</p></div></label>';
      }
      if(m.led){
        h+='<label class="extra-item'+(S.led?' selected':'')+'" onclick="sszToggle(\'led\')"><input type="checkbox"'+(S.led?' checked':'')+' onclick="event.preventDefault()">'
          +'<div><h4>GroJaGlow LED-Lichtleiste hinzufügen</h4><p>Warmweiße Zaunbeleuchtung 190 cm, IP65 – 1 Leiste je Pfosten ('+fmt(LED.price)+'/Stück). Trafo separat erforderlich.</p></div></label>';
      }
      h+='</div>';
    }
    else if(screen==='summary'){
      var r=calc();
      h+='<h2 class="konfig-step-title">Schritt 8: Deine Stückliste</h2><p class="konfig-step-sub">Alle Positionen auf einen Blick – direkt in den Warenkorb legen.</p>';
      if(!r){ h+='<div class="konfig-alert visible" style="position:static">Bitte vervollständige deine Konfiguration.</div>'; }
      else{
        var cc=colorObj();
        h+='<div class="summary-config"><strong>Konfiguration:</strong> '+m.name+' · '+cc.l+' · 180 cm Höhe · '+S.laenge+' m Länge · '
          +r.el+' Elemente, '+r.po+' Pfosten · '+(S.mount==='fussplatte'?'Fußplatte':'Einbetonieren')+'</div>';
        h+='<div class="summary-header">Stückliste</div><table class="summary-table"><thead><tr><th>Artikel</th><th>Menge</th><th>Einzelpreis</th><th>Gesamt</th></tr></thead><tbody>';
        for(var ri=0;ri<r.rows.length;ri++){ var row=r.rows[ri];
          h+='<tr><td>'+row.name+'</td><td>'+row.qty+'</td><td>'+fmt(row.ep)+'</td><td>'+fmt(row.sub)+'</td></tr>';
        }
        h+='</tbody><tfoot><tr class="total-row"><td colspan="3"><strong>Gesamtpreis (inkl. MwSt.)</strong></td><td>'+fmt(r.total)+'</td></tr></tfoot></table>';
        h+='<p style="font-size:.78rem;color:var(--grey);margin:0 0 1.5rem">Alle Preise inkl. 19 % MwSt. Versandkosten ab 999 € Bestellwert kostenlos.</p>';
        h+='<div class="konfig-trust">'
          +'<div class="trust-item">⭐ <strong>4,9</strong>&nbsp;Google-Bewertungen</div>'
          +'<div class="trust-item">🚚 <strong>Versandkostenfrei</strong>&nbsp;ab 999 €</div>'
          +'<div class="trust-item">📍 <strong>14 Abholstandorte</strong>&nbsp;deutschlandweit</div>'
          +'<div class="trust-item">🛡️ <strong>Wartungsfrei</strong>&nbsp;&amp; wetterfest</div>'
          +'</div>';
      }
    }

    h+='</div>'; /* /konfig-panel */
    h+='<div class="konfig-alert" id="ssz-alert"></div>';
    h+='<div class="konfig-nav">'
      +'<button class="btn-prev" onclick="sszBack(\''+screen+'\')">← Zurück</button>'
      +(screen==='summary'
        ? '<button class="btn-cart" id="ssz-cart" onclick="sszAddToCart()">🛒 In den Warenkorb</button>'
        : '<button class="btn-next" onclick="sszNext(\''+screen+'\')">Weiter →</button>')
      +'</div>';

    wrap.innerHTML=h;
    if(screen==='laenge') updatePreview();
    var top=wrap.offsetTop-80; window.scrollTo({top:top<0?0:top,behavior:'smooth'});
  }

  function updatePreview(){
    var el=document.getElementById('ssz-preview'); if(!el) return;
    var m=M(); var l=parseFloat(String(S.laenge).replace(',','.'))||0;
    if(l>0&&m){ var e=Math.ceil(l/m.ew);
      el.innerHTML='<div class="laenge-preview-item"><strong>'+e+'</strong><span>Elemente à '+(m.ew*100)+' cm</span></div>'
                  +'<div class="laenge-preview-item"><strong>'+(e+1)+'</strong><span>Pfosten (inkl. Ecken)</span></div>';
    } else { el.innerHTML='<div style="color:var(--grey);font-size:.85rem">Gib eine Länge ein, um die Stückliste zu sehen.</div>'; }
  }

  function warn(msg){ var a=document.getElementById('ssz-alert'); if(a){ a.textContent=msg; a.classList.add('visible'); } }

  function valid(cur){
    if(cur==='typ'&&!S.typ){ warn('Bitte wähle einen Zauntyp.'); return false; }
    if(cur==='modell'&&!S.model){ warn('Bitte wähle ein Modell.'); return false; }
    if(cur==='farbe'&&!S.color){ warn('Bitte wähle eine Oberfläche.'); return false; }
    if(cur==='laenge'){ var l=parseFloat(String(S.laenge).replace(',','.')); if(!l||l<=0){ warn('Bitte gib eine gültige Zaunlänge (in Metern) ein.'); return false; } }
    if(cur==='montage'&&!S.mount){ warn('Bitte wähle eine Bodenbefestigung.'); return false; }
    return true;
  }

  /* ---- global handlers ---- */
  window.sszPick=function(field,val){
    if(field==='typ'){ if(S.typ!==val){ S.typ=val; S.model=null; S.color=null; } render('typ'); }
    else if(field==='model'){ if(S.model!==val){ S.model=val; S.color=null; S.tor=false; S.torIdx=null; S.schraeg=false; S.led=false; } render('modell'); }
    else if(field==='color'){ S.color=val; render('farbe'); }
    else if(field==='mount'){ S.mount=val; render('montage'); }
  };
  window.sszToggle=function(f){ S[f]=!S[f]; render('extras'); };
  window.sszTor=function(on){ S.tor=on; if(on&&S.torIdx===null){ var m=M(),best=0; for(var i=0;i<m.tor.length;i++){ if(m.tor[i].k===S.color){ best=i; break; } } S.torIdx=best; } render('tor'); };
  window.sszTorSel=function(el){ S.torIdx=parseInt(el.value,10); };
  window.sszLen=function(el){ S.laenge=el.value; updatePreview(); };
  window.sszNext=function(cur){ if(!valid(cur)) return; var scr=screens(), i=scr.indexOf(cur); if(i>=0&&i<scr.length-1) render(scr[i+1]); };
  window.sszBack=function(cur){ var scr=screens(), i=scr.indexOf(cur); if(i<=0) window.kBackToStart(); else render(scr[i-1]); };

  window.sszAddToCart=function(){
    var r=calc(); if(!r||!r.items.length){ warn('Bitte vervollständige deine Konfiguration.'); return; }
    var btn=document.getElementById('ssz-cart'); if(btn){ btn.disabled=true; btn.textContent='Wird geladen…'; }
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:r.items})})
      .then(function(res){ if(!res.ok) throw new Error('Fehler'); window.location.href='/cart'; })
      .catch(function(err){ console.error(err); if(btn){ btn.disabled=false; btn.textContent='🛒 In den Warenkorb'; } warn('Es gab einen Fehler. Bitte versuche es erneut.'); });
  };

  /* ---- Startfrage ---- */
  window.kChooseCat=function(cat){
    var cat0=document.getElementById('konfig-cat');
    var dsm=document.getElementById('konfig-dsm');
    var ssz=document.getElementById('konfig-ssz');
    if(cat0) cat0.style.display='none';
    if(cat==='doppelstab'){ if(dsm) dsm.style.display=''; if(ssz) ssz.style.display='none'; }
    else { if(ssz) ssz.style.display=''; if(dsm) dsm.style.display='none'; render('typ'); }
    window.scrollTo({top:0,behavior:'smooth'});
  };
  window.kBackToStart=function(){
    var cat0=document.getElementById('konfig-cat');
    var dsm=document.getElementById('konfig-dsm');
    var ssz=document.getElementById('konfig-ssz');
    if(dsm) dsm.style.display='none';
    if(ssz) ssz.style.display='none';
    if(cat0) cat0.style.display='';
    window.scrollTo({top:0,behavior:'smooth'});
  };
})();
